import { render, staticRenderFns } from "./TrPagelink.vue?vue&type=template&id=f42831fe&scoped=true&"
import script from "./TrPagelink.vue?vue&type=script&lang=js&"
export * from "./TrPagelink.vue?vue&type=script&lang=js&"
import style0 from "./TrPagelink.vue?vue&type=style&index=0&id=f42831fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42831fe",
  null
  
)

export default component.exports